import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "@similarweb/ui-components";

const { carbon } = colorsPalettes;

export const TooltipContainer = styled(FlexColumn)`
    align-items: start;
    justify-content: center;
    ${setFontVariant("body2")};
    width: 186px;
`;

export const Name = styled.div`
    ${setFontVariant("listItem3", carbon[400])};
`;

export const Value = styled.div`
    ${setFontVariant("body2", carbon[500])};
`;

export const Duration = styled.div`
    ${setFontVariant("subtitle2", carbon[400])};
    margin-bottom: 16px;
`;

export const EmptyValue = styled(FlexRow)`
    justify-content: center;
    align-items: center;
`;
